import type {GenerateAiVideoParams} from '@Libraries/ai-video.library';
import type {AiVideoQuality} from '@Panels/ai-video-panel/ai-video-panel.types';

export enum AiImageState {
  IDLE = 'IDLE',
  GENERATING = 'GENERATING',
  READY = 'READY',
}

export enum AiSubtitleState {
  IDLE = 'IDLE',
  GENERATING = 'GENERATING',
  READY_SUCCESS = 'READY_SUCCESS',
  READY_FAILED = 'READY_FAILED',
}

export enum AiVoiceState {
  IDLE = 'IDLE',
  GENERATING = 'GENERATING',
  READY = 'READY',
  ERROR = 'ERROR',
}

export enum AiVideoGenerationStatus {
  PENDING = 'PENDING',
  GENERATING = 'GENERATING',
  ERROR = 'ERROR',
}

export interface AiVideosState {
  id: string;
  status: AiVideoGenerationStatus;
  params: GenerateAiVideoParams;
  errorCode?: string;
}

export enum PosterAnimationGenerationStatus {
  GENERATING = 'GENERATING',
  ERROR = 'ERROR',
  PENDING = 'PENDING',
}

export interface PosterAnimationGenerationParams {
  quality: AiVideoQuality;
  generateAudio: boolean;
  prompt: string;
}

export interface PosterAnimationGenerationState {
  id: string;
  status: PosterAnimationGenerationStatus;
  width: number;
  height: number;
  params: PosterAnimationGenerationParams;
  errorCode?: string;
}

export interface AiState {
  aiImage: AiImageState;
  aiSubtitles: AiSubtitleState;
  aiVoice: AiVoiceState;
  aiVideo: AiVideosState[];
  aiPosterAnimation: PosterAnimationGenerationState[];
  aiCredits: number | null;
}
